// import GLightbox from "glightbox";
import "bootstrap/dist/js/bootstrap.bundle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Swiper from "swiper/bundle";
import observeStickyElement from "./stickyStuck";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import AOS from "aos";
// import Alpine, { effect } from "alpinejs";
// window.Alpine = Alpine;
// Alpine.start();
// const lightbox = GLightbox();
// new Splide(".splide").mount();
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
document.addEventListener("DOMContentLoaded", function () {
	AOS.init();

	var elms = document.getElementsByClassName("jsCarousel");

	for (var i = 0; i < elms.length; i++) {
		new Splide(elms[i], {
			type: "loop",
			drag: "free",
			focus: "center",
			perPage: 5,
			arrows: false,
			pagination: false,
			autoWidth: true,
			autoScroll: {
				speed: 1,
			},
		}).mount({ AutoScroll });
	}

	observeStickyElement();

	ScrollTrigger.create({
		start: "top -80",
		end: 99999,
		toggleClass: {
			className: "is-stuck",
			targets: ".main-nav",
		},
	});
	// Hover dropdown functionality
	const dropdownHovers = document.querySelectorAll(".dropdown-hover");

	dropdownHovers.forEach((dropdown) => {
		const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
		const dropdownMenu = dropdown.querySelector(".dropdown-menu");

		// Handle hover events for desktop
		dropdown.addEventListener("mouseenter", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.add("show");
				dropdownToggle.setAttribute("aria-expanded", "true");
			}
		});

		dropdown.addEventListener("mouseleave", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.remove("show");
				dropdownToggle.setAttribute("aria-expanded", "false");
			}
		});

		// Handle click on mobile devices
		dropdownToggle.addEventListener("click", function (e) {
			if (window.innerWidth <= 991) {
				// Only on mobile
				e.preventDefault();
				const isOpen = dropdownMenu.classList.contains("show");

				// Close all other dropdowns
				dropdownHovers.forEach((otherDropdown) => {
					if (otherDropdown !== dropdown) {
						otherDropdown
							.querySelector(".dropdown-menu")
							.classList.remove("show");
						otherDropdown
							.querySelector(".dropdown-toggle")
							.setAttribute("aria-expanded", "false");
					}
				});

				// Toggle current dropdown
				if (isOpen) {
					dropdownMenu.classList.remove("show");
					dropdownToggle.setAttribute("aria-expanded", "false");
				} else {
					dropdownMenu.classList.add("show");
					dropdownToggle.setAttribute("aria-expanded", "true");
				}
			}
		});
	});

	// Close dropdowns when clicking outside on mobile
	document.addEventListener("click", function (e) {
		if (window.innerWidth <= 991 && !e.target.closest(".dropdown-hover")) {
			dropdownHovers.forEach((dropdown) => {
				dropdown.querySelector(".dropdown-menu").classList.remove("show");
				dropdown
					.querySelector(".dropdown-toggle")
					.setAttribute("aria-expanded", "false");
			});
		}
	});

	if (document.querySelector(".jsTestimonials")) {
		document.querySelectorAll(".jsTestimonials").forEach((test) => {
			new Splide(test, {
				type: "loop",
				pagination: false,
				perPage: 2,
				autoplay: true,
				interval: 3000,
				pauseOnHover: true,
				pauseOnFocus: true,
				gap: "1rem",
				breakpoints: {
					320: {
						perPage: 1,
					},
					768: {
						perPage: 2,
					},
				},
			}).mount();
		});
	}

	document.querySelectorAll(".impact__inner").forEach((impact) => {
		// Prepare for CSS-driven animation by applying initial state class
		impact.classList.add("impact-js");
	});

	// Use IntersectionObserver to add visibility class when in viewport
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-visible");
					obs.unobserve(entry.target); // animate once
				}
			});
		},
		{
			root: null,
			threshold: 0.4, // adjust sensitivity
		}
	);

	document
		.querySelectorAll(".impact__inner")
		.forEach((el) => observer.observe(el));
});
